import {
     GET_CATEGORIES
} from './type';
import ProductsUpload from '../Models/ProductsUpload';


export const productUpload = (productData, history) => dispatch => {
    ProductsUpload.create(productData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                history.push('/seller-dashboard');
            } else {
                console.log(res.data.message);
            }
        })
        .catch(
            console.log('error')
        )
};
export const productUploadCategory = () => dispatch => {
    ProductsUpload.getCategory()
        .then(res => {
            dispatch({
                type: GET_CATEGORIES,
                payload: res.data
            })
        })
        .catch(
            console.log("error")
        )
};
// export const buyerLogin = (buyerData) => {
//     return {
//         type: BUYER_LOGIN,
//         payload: buyerData,
//     }
// };